<template>
  <transition name="post-notify-fade">
    <div class="post-notify-mask" role="dialog" aria-modal="true" @click.self="close">
      <div class="post-notify-card" :class="'is-' + type">
        <div class="post-notify-accent" :class="'a-' + type" />
        <div class="post-notify-body">
          <div class="post-notify-icon-wrap" :class="'t-' + type">
            <span v-if="type === 'success'" class="post-notify-ico" aria-hidden="true">✓</span>
            <span v-else-if="type === 'error'" class="post-notify-ico" aria-hidden="true">✕</span>
            <span v-else class="post-notify-ico post-notify-ico--info" aria-hidden="true">!</span>
          </div>
          <h3 class="post-notify-title">{{ displayTitle }}</h3>
          <p class="post-notify-message">{{ message }}</p>
        </div>
        <button type="button" class="post-notify-btn" @click="close">{{ btnText }}</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PostResultNotify',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (v) => ['success', 'error', 'warning', 'info'].includes(v),
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '確定',
    },
  },
  computed: {
    displayTitle() {
      if (this.title) return this.title
      if (this.type === 'success') return '操作成功'
      if (this.type === 'error') return '操作失敗'
      if (this.type === 'warning') return '提示'
      return '提示'
    },
  },
  mounted() {
    this._prevBodyOverflow = document.body.style.overflow
    this._prevHtmlOverflow = document.documentElement.style.overflow
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = this._prevBodyOverflow || ''
    document.documentElement.style.overflow = this._prevHtmlOverflow || ''
  },
  methods: {
    close() {
      this.$emit('closed')
    },
  },
}
</script>

<style scoped>
.post-notify-mask {
  position: fixed;
  inset: 0;
  z-index: 200000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.post-notify-card {
  position: relative;
  width: 100%;
  max-width: 340px;
  overflow: hidden;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 22px 50px rgba(0, 0, 0, 0.18), 0 0 1px rgba(0, 0, 0, 0.08);
}

.post-notify-accent {
  height: 4px;
  background: linear-gradient(90deg, #64748b, #94a3b8);
}
.post-notify-accent.a-success {
  background: linear-gradient(90deg, #059669, #34d399);
}
.post-notify-accent.a-error {
  background: linear-gradient(90deg, #dc2626, #f87171);
}
.post-notify-accent.a-warning {
  background: linear-gradient(90deg, #d97706, #fbbf24);
}
.post-notify-accent.a-info {
  background: linear-gradient(90deg, #2563eb, #60a5fa);
}

.post-notify-body {
  padding: 22px 22px 8px;
  text-align: center;
}

.post-notify-icon-wrap {
  width: 52px;
  height: 52px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}
.post-notify-icon-wrap.t-success {
  background: #ecfdf5;
  color: #059669;
  border: 2px solid #a7f3d0;
}
.post-notify-icon-wrap.t-error {
  background: #fef2f2;
  color: #dc2626;
  border: 2px solid #fecaca;
}
.post-notify-icon-wrap.t-warning {
  background: #fffbeb;
  color: #d97706;
  border: 2px solid #fde68a;
}
.post-notify-icon-wrap.t-info {
  background: #eff6ff;
  color: #2563eb;
  border: 2px solid #bfdbfe;
}

.post-notify-ico--info {
  font-size: 22px;
  font-weight: 800;
  font-family: Georgia, serif;
}

.post-notify-title {
  margin: 0 0 10px;
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.02em;
}

.post-notify-message {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #475569;
  word-break: break-word;
  white-space: pre-wrap;
}

.post-notify-btn {
  display: block;
  width: 100%;
  margin: 0;
  padding: 14px 16px;
  border: none;
  border-top: 1px solid #e2e8f0;
  background: linear-gradient(to bottom, #fafafa, #f1f5f9);
  color: #0f172a;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.post-notify-btn:hover {
  background: #e2e8f0;
}
.post-notify-btn:active {
  background: #cbd5e1;
}

.post-notify-fade-enter-active,
.post-notify-fade-leave-active {
  transition: opacity 0.2s ease;
}
.post-notify-fade-enter-active .post-notify-card,
.post-notify-fade-leave-active .post-notify-card {
  transition: transform 0.22s cubic-bezier(0.34, 1.2, 0.64, 1);
}
.post-notify-fade-enter,
.post-notify-fade-leave-to {
  opacity: 0;
}
.post-notify-fade-enter .post-notify-card,
.post-notify-fade-leave-to .post-notify-card {
  transform: scale(0.94) translateY(8px);
}
</style>
